(ns common.schema.entities.workspace.kyc.templates.capman.contract-ubo
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]))

(defn mandatory-when-not-draft
  "Returns true when kyc-process is not in draft status, making fields mandatory after draft."
  [_answers kyc-process]
  (not= (:kyc-process/status kyc-process)
        :kyc-process.status/draft))

(def mandatory-when-not-draft-meta
  {:mandatory-field? mandatory-when-not-draft})

(def schema
  {:kyc-template/template-name
   "UBO"
   :kyc-template/kyc-form-preface
   {:translations {:en "Ultimate beneficial owners (UBO)"
                   :fi "Yhteisön tosiasialliset edunsaajat"}}

   :kyc-ubo.group/ubo-position
   {:ord          1.0
    :translations {:en "Reason for UBO"
                   :fi "Peruste"}
    :conditional-block (fn [_answers kyc-process]
                         (not (templates/natural-person-templates-keys (:kyc-process/template kyc-process))))
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/primary-ubo-category]
                    [:kyc-ubo/ubo-category-ownership]
                    [:kyc-ubo/ubo-category-voting-rights]
                    [:kyc-ubo/ubo-category-position]])}

   :kyc-ubo.group/basic-information
   {:ord          2.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/first-name mandatory-when-not-draft-meta]
                    [:kyc-ubo/last-name mandatory-when-not-draft-meta]
                    [:kyc-ubo/dob mandatory-when-not-draft-meta]
                    [:kyc-ubo/nationality mandatory-when-not-draft-meta]])}})

